/**
 * @description: 一键起量状态枚举值
 * @return {*}
 */
export const AUTO_ACQUISITION_STATUS = {
  UNKNOWN: 0,
  CLOSED: 1,
  DISABLED: 2,
  ENABLE: 3,
  FINISHED: 4,
  RESERVABLE: 5,
  RESERVED: 6
}

/**
 * @description: 一键起量状态枚举值列表
 * @return {*}
 */
export const AUTO_ACQUISITION_STATUS_LIST = [
  {
    value: AUTO_ACQUISITION_STATUS.UNKNOWN,
    label: '未知'
  },
  {
    value: AUTO_ACQUISITION_STATUS.CLOSED,
    label: '未开启'
  },
  {
    value: AUTO_ACQUISITION_STATUS.DISABLED,
    label: '不可用'
  },
  {
    value: AUTO_ACQUISITION_STATUS.ENABLE,
    label: '起量中'
  },
  {
    value: AUTO_ACQUISITION_STATUS.FINISHED,
    label: '已完成'
  },
  {
    value: AUTO_ACQUISITION_STATUS.RESERVABLE,
    label: '可预约'
  },
  {
    value: AUTO_ACQUISITION_STATUS.RESERVED,
    label: '已预约'
  }
]

export const EMPTY_VALUE = '-'
